import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { useChatContext } from '../../../../../../contexts/chat/chat.context';
import { ChatViewType } from '../../../../../../contexts/chat/reducer/chatReducer.types';
import ChatHeaderTemplate from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';

const ChatFormHeader = () => {
  const { translate } = useTranslation();

  const { view } = useChatContext();

  const getText = (): LangEnum => {
    switch (view.type) {
      case ChatViewType.GroupCreation:
        return LangEnum.CHAT_HEADER_CREATE_GROUP;
      case ChatViewType.PrivateCreation:
        return LangEnum.GLOBAL_NEW_CHAT;

      default:
        return LangEnum.GLOBAL_NEW_CHAT;
    }
  };

  return (
    <ChatHeaderTemplate.Template>
      <ChatHeaderTemplate.Title text={translate(getText())} />
    </ChatHeaderTemplate.Template>
  );
};

export default ChatFormHeader;
